import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import ImageListItemBar from '@mui/material/ImageListItemBar';
import IconButton from '@mui/material/IconButton';
import StarBorderIcon from '@mui/icons-material/StarBorder';

/* __next_internal_client_entry_do_not_use__ default auto */ import { createDemoClient } from '@mui/internal-core-docs/utils/createDemoClient';
const ClientProvider = createDemoClient(import.meta.url, { precompute: { externals: { "@mui/material/ImageList": ImageList, "@mui/material/ImageListItem": ImageListItem, "@mui/material/ImageListItemBar": ImageListItemBar, "@mui/material/IconButton": IconButton, "@mui/icons-material/StarBorder": StarBorderIcon } } });
export default ClientProvider;
